import React, { useContext, useEffect, useState } from "react";
import "./SingleRangeBox.scss";

import { useIntl } from "react-intl";
import { translateMessage } from "src/app/methods/translateMessage";

import CustomInput from "src/app/components/CustomInput/CustomInput";
import { valueExists } from "src/app/methods/valueExists";
import { DictionaryFiltersContext } from "../../DictionaryFilters";

export function SingleRangeBox({ col, setWaitEvent }) {
  const intl = useIntl();

  const { dictionaryFilters } = useContext(DictionaryFiltersContext);
  const { filters } = dictionaryFilters;

  const [value, setValue] = useState(filters[col.uuid]?.value.from);
  const [value2, setValue2] = useState(filters[col.uuid]?.value.to);

  useEffect(() => {
    (value !== undefined || value2 !== undefined) &&
      (value !== filters[col.uuid]?.value.from ||
        value2 !== filters[col.uuid]?.value.to) &&
      setWaitEvent({
        target: {
          value:
            !valueExists(value) && !valueExists(value2)
              ? undefined
              : { from: value, to: value2 },
        },
      });
  }, [value, value2]);

  return (
    <div className="single-range-box">
      <CustomInput
        value={value}
        onChange={(e) => setValue(e.target.value)}
        type="number"
        placeholder={translateMessage({
          intl,
          id: "ws_from",
          defaultMessage: "From",
        })}
        data-qa={`${col.name}-from`}
      />
      <CustomInput
        value={value2}
        onChange={(e) => setValue2(e.target.value)}
        type="number"
        placeholder={translateMessage({
          intl,
          id: "ws_to",
          defaultMessage: "To",
        })}
        data-qa={`${col.name}-to`}
      />
    </div>
  );
}
